function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.426 81.142L20.88 78.61V48.244c0-14.622 11.963-26.517 26.668-26.517h6.515c14.705 0 26.67 11.895 26.67 26.517s-11.965 26.519-26.67 26.519H36.187c-.296 0-.584.105-.813.293l-.349.248-9.6 5.838z",
  fill: "#3A77FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.637 54.399l-.349-.248a1.283 1.283 0 00-.814-.293H27.6c-14.705 0-26.67-11.897-26.67-26.52C.93 12.719 12.894.823 27.6.823h6.515c14.704 0 26.668 11.895 26.668 26.517v30.364l-4.546 2.534-9.6-5.838z",
  fill: "#CEDDFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M44.71 36.707S34.092 49.582 21.434 35.48",
  stroke: "#002F34",
  strokeWidth: 5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.928 14.575c-4.438 0-8.035 3.571-8.035 7.977 0 4.406 3.597 7.977 8.035 7.977 4.438 0 8.036-3.571 8.036-7.977 0-4.406-3.598-7.977-8.036-7.977zm0 5.584c1.33 0 2.411 1.074 2.411 2.393a2.405 2.405 0 01-2.41 2.393 2.405 2.405 0 01-2.411-2.393 2.405 2.405 0 012.41-2.393z",
  fill: "#002F34"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M44.71 22.002h-9.42",
  stroke: "#002F34",
  strokeWidth: 5
});

const SvgChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 81,
  height: 82,
  fill: "none"
}, props), _ref, _ref2, _ref3, _ref4, _ref5);

export default SvgChat;